<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="!loadDone">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardPopupImg
        :cardContent="content"
        :cardType="cardType"
        :isModalVisible="isShow"
        @popupData2="popupData2"
        :CheckWidth="CheckWidth"
        :score="score"
        :maxscore="maxscore"
        @updateUser="updateUser"
      />
    </template>
  </div>
</template>

<script>
import LoadingMDL from "../../components/loading/LoadingMDL";
import CardPopupImg from "../../components/template/Chinese1/CardPopupImg";
import { mapGetters } from "vuex";
import "../../assets/scss/_chineseStyle.scss";
import "../../assets/scss/_chineseModalCustom.scss";
import TEMPLATE from "../../TEMPLATE.vue";

export default {
  components: { CardPopupImg, TEMPLATE, LoadingMDL },
  name: "LKS01",
  data() {
    return {
      code: "",
      lang: "",
      content: {},
      type: "",
      isShow: true,
      cardType: "score",
      openModalImage: true,
      score: 0,
      CheckWidth: window.innerWidth.toString(),
      maxscore: 0,
      LessonID: 0,
      mode: {},
      assignmentTestScore: {},
      prepostTestScore: {},
      courseSection: "",
      startTime: "",
      courseCode: "",
      condition: [],
      courseSection: "",
      loadDone: false,
    };
  },

  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      assignmentTest: "template/getAssignmentTest",
      preposttest: "template/getPrePostTest",
      getDisplayScore: "template/getDisplayScore",
      getUserTemplate: "template/getUserTemplate",
    }),
  },

  watch: {
    allCourse: function(val) {
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.content = val;
        let body = {
          code: this.courseCode,
          template: val._id,
        };
        this.$store.dispatch("template/fetchScore", body);
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });
      }
    },
    getDisplayScore: function(val) {
      this.score = val.totalQuizScore;
      this.maxscore = val.maxScore;
      this.loadDone = true;
    },
    preposttest: function(val) {
      this.maxscore = val.fullscore;
      if (this.mode.posttestMode == true) {
        this.score = val.userscore;
      } else if (this.mode.pretestMode == true) {
        this.score = val.userscore;
      } else {
        this.score = this.$store.getters["score/getPoint"];
      }
    },
    assignmentTest: function(val) {
      this.assignmentTestScore = val;
      this.maxscore = this.assignmentTestScore.fullscore;
      if (this.mode.assingmentmode == true) {
        this.score = this.assignmentTestScore.userscore;
      } else if (this.mode.testmode == true) {
        this.score = this.assignmentTestScore.userscore;
      } else {
        this.score = this.$store.getters["score/getPoint"];
      }
    },
    getUserTemplate: function(val) {
      this.condition =
        typeof val.data.condition.criteriaType == "undefined" ||
        val.data.condition.criteriaType.length == 0
          ? []
          : [
              {
                criteria: val.data.condition.criteriaType[0].criteria._id,
                val: val.data.condition.criteriaType[0].val,
              },
            ];
    },
  },

  mounted() {
    this.lang = this.$store.state.language.language;
    let body = {};
    body.code = this.courseCode;
    body.templateCode = `LKS01-` + this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
  },

  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
    this.startTime = this.$helpers.getDateFormat();
  },

  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
      // return "container-chinese-card-mobile"
    },
    popupData2: function(val) {},
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    updateUser() {
      let body = {
        code: this.courseCode,
        template: this.content._id,
        section: this.courseSection,
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
      };
      this.$store.dispatch("template/saveUserTemplateData", body);
    },
  },
};
</script>
<style></style>
